import { NotEmptyString } from "../../../../../Validation/Validation"
import FormTextInputWrapper from "./FormTextInputWrapper"
import { UseFormRegister } from "react-hook-form"

interface IFormAddress {
    value: IAddress,
    onChange: Function,
    required: boolean,
    validateRule?: Function,
    validationError?: string
    register?: UseFormRegister<Record<string, any>>
    fieldPrefix?: string
}

export interface IAddress {
    companyStreet: string
    address1: string
    address2: string
    city: string
    county: string
    zip: string
    country: string
}

export default function FormAddress({ value, onChange, required, validateRule, validationError, register, fieldPrefix }: IFormAddress) {
    const prefix = fieldPrefix ? `${fieldPrefix}.` : '';

    return (<>
        <div className="grid-x grid-padding-x grid-padding-y">
            <FormTextInputWrapper
                label={"Company"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, companyStreet: val })}
                value={value.companyStreet}
                required={true}
                validateRule={NotEmptyString}
                validationError={'Company cannot be empty'}
                autocomplete="organization"
                name="companyStreet"
                register={register ? register(`${prefix}companyStreet` as any) : undefined} />

            <FormTextInputWrapper
                label={"Address line 1"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, address1: val })}
                value={value.address1}
                required={true}
                validateRule={NotEmptyString}
                validationError={'Line 1 cannot be empty'}
                autocomplete="address-line1"
                name="address1"
                register={register ? register(`${prefix}address1` as any) : undefined} />

            <FormTextInputWrapper
                label={"Address line 2"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, address2: val })}
                value={value.address2}
                required={false}
                autocomplete="address-line2"
                name="address2"
                register={register ? register(`${prefix}address2` as any) : undefined} />

            <FormTextInputWrapper
                label={"City/Town"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, city: val })}
                value={value.city}
                required={true}
                validateRule={NotEmptyString}
                validationError={'City/town cannot be empty'}
                autocomplete="address-level2"
                name="city"
                register={register ? register(`${prefix}city` as any) : undefined} />

            <FormTextInputWrapper
                label={"County"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, county: val })}
                value={value.county}
                required={false}
                autocomplete="address-level1"
                name="county"
                register={register ? register(`${prefix}county` as any) : undefined} />

            <FormTextInputWrapper
                label={"Zip/Post code"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, zip: val })}
                value={value.zip}
                required={true}
                validateRule={NotEmptyString}
                validationError={'Zip/Post code cannot be empty'}
                autocomplete="postal-code"
                name="zip"
                register={register ? register(`${prefix}zip` as any) : undefined} />

            <FormTextInputWrapper
                label={"Country"}
                className="cell small-6"
                onChange={(val: any) => onChange({ ...value, country: val })}
                value={value.country}
                required={false}
                autocomplete="country"
                name="country"
                register={register ? register(`${prefix}country` as any) : undefined} />
        </div>
    </>)
}